// extracted by mini-css-extract-plugin
export var cardIcon = "_4z-4";
export var checkboxCard = "_4z-0";
export var checkboxCardSelected = "_4z-1";
export var disabled = "_4z-2";
export var outerBorder = "_4z-3";
export var spacerMedium = "_4z-7";
export var spacerSmall = "_4z-6";
export var spacerXsmall = "_4z-5";